import MessageBus from '../../ports-frontend/MessageBus';
import Promotions, { ViewMode } from '../../ports-frontend/Promotions';

export const SOCKET_ID = 'basecamp-container';

export const createPromotionsModel = () => {
  const model = {
    async startPromotionsFlow(viewMode: ViewMode) {
      await Promotions.startPromotions(SOCKET_ID, viewMode);
    },

    async stopPromotionsFlow() {
      await Promotions.stopPromotions();
    },

    async showPromotionsList(locale: string) {
      await Promotions.showPromotionsList(locale);
    },

    async showPromotionsDetails(slug: string, locale: string) {
      await Promotions.showPromotionsDetails(slug, locale);
    },

    async watchPromotionsEvents({ callback }: { callback: Function }) {
      const unsubscribeShowDetails = await MessageBus.onSubscribe(
        ({ payload: { promotionSlug, promotionLangCode } }) => {
          callback({
            type: 'PROMOTION_DETAILS_DISPLAYED',
            payload: {
              pageSlug: promotionSlug,
              promotionLangCode: promotionLangCode,
            },
          });
        },
        ['wh.common.event.ui.promotions.showDetails']
      );

      const unsubscribeShowList = await MessageBus.onSubscribe(
        ({ payload: { promotionLangCode } }) => {
          callback({
            type: 'PROMOTION_LIST_DISPLAYED',
            payload: { promotionLangCode },
          });
        },
        ['wh.common.event.ui.promotions.showList']
      );

      const unsubscribeGameLaunch = await MessageBus.onSubscribe(
        ({ payload }) => {
          callback({
            type: 'PROMOTIONS_GAME_OPEN_CLICK',
            payload: { presentationCode: payload.presentationCode },
          });
        },
        ['wh.common.event.ui.promotions.gameLaunch']
      );

      return () => {
        unsubscribeShowDetails();
        unsubscribeShowList();
        unsubscribeGameLaunch();
      };
    },
  };

  return model;
};
